<aside class="l-sidebar l-flex l-column">
    <img class="off-mobile sidebar-logo" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
    <app-docpanel></app-docpanel>
    <div class="userPanel"></div>
    <app-bar (pageChange)="setPage($event)"></app-bar>
    <nav class="mainNav l-fg1 scroller"></nav>
  
  </aside>
  <!-- ========================== header (start) ========================== -->
  <header class="l-header">
  
    <div class="on-mobile header-logo">
      <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
    </div>
    <div class="l-header-panel" style="display: flex;
    flex-direction: row;
    justify-content: space-between;
    
  ">
       <div *ngIf="ls.clinicUsers && page!=='exams' && page!='Sms'" style="right: 10em">
        <div class="l-flex l-flex-c t-field t-field-pad">
          <label matTooltip="שם הרופא">
            <img src="../../assets/icons/drb.svg" />
          </label>
  
          <i class="t-sep"></i>
  
          <span class="t-validation-wrap l-fg1">
            <select
              [(ngModel)]="ls.doctor"
              class="t-select w100"
              style="text-align: center"
            >
            <option *ngIf="page=='search'" [ngValue]="null">All</option>
              <ng-container *ngFor="let e of ls.clinicUsers">
                <option [value]="e.UID">{{ e.Name }}</option>
              </ng-container>
            </select>
          </span>
        </div>
      </div>
      <div style="display: flex;
      flex-direction: row;
      width: 7%;
      justify-content: space-between;">
        <img
        style="cursor: pointer"
        matTooltip="back to calendar"
        height="41em"
        width="41em"
        src="../../assets/icons/exit.svg"
        (click)="goToCalendar()"
        />
       
  
        
    </div>
    </div>
  </header>
  <app-exams-names *ngIf="page=='exams'"></app-exams-names>
  <app-activity-hours *ngIf="page=='Activity Hours'" [selectedUserId]="ls.doctor"></app-activity-hours>
  <app-search *ngIf="page=='Reports'"></app-search>
  <app-sms-settings *ngIf="page=='Sms'"></app-sms-settings>
  <app-commerror></app-commerror> 
<app-bottombar></app-bottombar>
